import React, { useEffect, useState, useCallback } from "react";
import api from "../../../axiosConfig";
import Select from "react-select";
import "../../../styles/TableStyles.css";

const LeaveRecords = () => {
  const [records, setRecords] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [statusFilter, setStatusFilter] = useState("pending cancellation");
  const [pageSize] = useState(10);

  const token = localStorage.getItem("accessToken");

  const statusOptions = [
    { value: "pending cancellation", label: "Pending Cancellation" },
    { value: "applied", label: "Applied" },
    { value: "approved cancellation", label: "Approved Cancellation" },
    { value: "rejected cancellation", label: "Rejected Cancellation" },
  ];

  const fetchLeaveRecords = useCallback(async (page) => {
    try {
      const res = await api.post(
        "/leave/list", 
        {
          searchString,
          skip: (page - 1) * pageSize,
          take: pageSize,
          status: statusFilter,
        },
        { headers: { Authorization: token } }
      );

      setRecords(res.data.data || []);
      setTotalPages(res.data.pagination.totalPages);
      setCurrentPage(res.data.pagination.currentPage);
    } catch (err) {
      console.error("Error fetching leave records:", err);
    }
  }, [searchString, pageSize, statusFilter, token]);

  useEffect(() => {
    fetchLeaveRecords(currentPage);
  }, [currentPage, fetchLeaveRecords]);

  return (
    <div className="table-responsive">
      <h2>Leave Records</h2>

      <div className="flex-wrap-row">
        <input
          className="item-m"
          type="text"
          placeholder="Search user..."
          value={searchString}
          onChange={(e) => setSearchString(e.target.value)}
        />
        <Select
          options={statusOptions}
          value={statusOptions.find((o) => o.value === statusFilter)}
          onChange={(option) => setStatusFilter(option.value)}
          className="item-m"
          classNamePrefix="react-select"
          isSearchable={false}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 9999})
          }}
        />
      </div>

      {records.length > 0 ? (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>User</th>
                <th>Type</th>
                <th>From</th>
                <th>To</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {records.map((r) => (
                <tr key={r.id}>
                  <td>{r.username}</td>
                  <td>{r.leave_type_name}</td>
                  <td>{r.date_from}</td>
                  <td>{r.date_to}</td>
                  <td>{r.status}</td>
                  <td>
                    <button className="table-action-button">Approve</button>
                    <button className="table-action-button reject">Reject</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button
              className="pagination-button"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            >
              Previous
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button
              className="pagination-button"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <p>No leave records found.</p>
      )}
    </div>
  );
};

export default LeaveRecords;
